import { Gym, IAlertData } from 'fitbeat.models';
import { AlertEntry } from '../../../entities/alert';
import { IAlertRepository } from '../interfaces/ialert-repository';

export class DbAlertRepository implements IAlertRepository {
    constructor(private alertDb: any) { }

    public async add(alert: IAlertData): Promise<AlertEntry> {
        const alertEntry = new AlertEntry(
            alert.type,
            alert.severity,
            alert.title,
            alert.message,
            alert.gymName,
            alert.createdAt,
            alert.userId);
        const doc = JSON.parse(JSON.stringify(alertEntry));
        doc._id = alertEntry.uid;
        await this.alertDb.put(doc);
        return alertEntry;
    }
    public async getAll(gym: Gym): Promise<AlertEntry[]> {
        const queryOptions = {
            selector: {
                gymName: gym.name,
            },
            use_index: [
                '_design/gymNameIndex',
                'gymNameIndex',
            ],
        };
        const results: any = await this.alertDb.find(queryOptions);
        const docs = results.docs;
        const alerts: AlertEntry[] = docs.map((doc: any) => {
            return this.assignToAlertObject(doc);
        });
        return alerts;
    }
    public async get(uid: string): Promise<AlertEntry | undefined> {
        try {
            const alert = this.assignToAlertObject(await this.alertDb.get(uid));
            return alert;
        } catch (err) {
            if (err.status === 404) {
                return undefined;
            } else {
                throw err;
            }
        }
    }
    public async getAllActive(gym: Gym): Promise<AlertEntry[]> {
        const queryOptions = {
            selector: {
                resolved: false,
                gymName: gym.name,
            },
            use_index: [
                '_design/gymNameIndex',
                'gymNameIndex',
            ],
        };
        const entries = (await this.alertDb.find(queryOptions)).docs.map((entry: any) =>
            this.assignToAlertObject(entry));
        return entries;
    }
    public async update(alert: AlertEntry): Promise<AlertEntry> {
        const doc = JSON.parse(JSON.stringify(alert));
        await this.alertDb.put(doc);
        return alert;
    }

    private assignToAlertObject(entry: any): AlertEntry {
        const returnObject = Object.assign(
            new AlertEntry(entry.type, entry.severity, entry.title, entry.message, entry.createdAt, entry.userId),
            entry);
        returnObject._id = entry._id;
        returnObject._rev = entry._rev;
        returnObject.createdAt = new Date(entry.createdAt);
        return returnObject;
    }
}
